angular.module('env.custom.customResourceResolver',
    [
        'env.customConfig'
    ])

    .service('customResourceResolver', function customResourceResolver($q, $log, $customisationConfig, context) {
        var cf = $customisationConfig;
        var q = $q;

        // Resolves the particular customised resource from the particular customisation configuration section
        // Accepts also the default value to return if nothing was found and any context data that should be
        // analyzed by the customisation configuration's internal resolvers/conditions
        var resolveFromConfig = function (config, name, _default, contextData) {

            // Temp logging feature to catch bugs with missing user
            // TODO remove after investigation
            //let err = new Error();
            // ----------

            //Context service will return context object with current user set on it along with any data supplied

            return context.getCurrent(contextData).then(function (currentContext) {

                var result;
                //Set customised resources map onto context so it will be available later from inside the
                //'resolve()' methods in the customised resources declarations
                currentContext.customResourcesMap = cf.customResourcesMap;

                for (var i = 0; i < config.length; ++i) {
                    var c = config[i];
                    if (angular.isDefined(c.name) && angular.isString(c.name) && c.name == name) {

                        //See if we have a 'resolve' method defined on the config section
                        if (angular.isDefined(c.resolve) && angular.isFunction(c.resolve)) {
                            var r;
                            try {
                                r = c.resolve(currentContext);
                            } catch (ex) {
                                //$log.warn(`Base call stack: `, err.stack); // TODO remove after investigation
                                $log.error("Error in the `resolve()` method of `" + name +
                                    "` case of the customisation config. Check please `customise/config*.js` configuration files.", ex);
                            }
                            if (r) {
                                result = r;
                                break;
                            }
                        }
                        //Looks like we don't have resolve method, so try to check for options defined
                        //Options are a simpler variant of 'resolve', useful for arrays of values
                        if (angular.isDefined(c.options) && angular.isArray(c.options)) {

                            for (var j = 0; j < c.options.length; ++j) {
                                var opt = c.options[j];
                                if (angular.isDefined(opt.condition) && angular.isFunction(opt.condition)) {
                                    var cond;
                                    try {
                                        cond = opt.condition(currentContext);
                                    } catch (ex) {
                                        //$log.warn(`Base call stack: `, err.stack); // TODO remove after investigation
                                        $log.error("Error in the `condition()` method of `" + name +
                                            "` case of the customisation config. Check please `customise/config*.js` configuration files.", ex);
                                    }
                                    if (cond) {
                                        if (cond == true && angular.isDefined(opt.value)) {
                                            result = opt.value;
                                        } else {
                                            result = cond;
                                        }
                                        break;
                                    }
                                } else {
                                    if (angular.isDefined(opt.value)) {
                                        result = opt.value;
                                        break;
                                    }
                                }
                            }

                        }

                        if (result) break;
                    }
                }

                return q.when(result || _default);
            });
        };

        //region Public methods

        /**
         * Promise.
         * Resolves custom directive name
         * @param name - alias name of the directive
         * @param _default - default value
         */
        this.resolveDirective = function (name, _default, conditionContext) {
            return resolveFromConfig(cf.directives, name, _default, conditionContext);
        };

        /**
         * Promise.
         * Resolves custom image url
         * @param name - alias name of the image
         * @param _default - default value
         */
        this.resolveImage = function (name, _default, conditionContext) {
            return resolveFromConfig(cf.images, name, _default, conditionContext);
        };

        /**
         * Promise.
         * Resolves custom HTML template url
         * @param name - alias name of the HTML template
         * @param _default - default value
         */
        this.resolveTemplateUri = function (name, _default, conditionContext) {
            return resolveFromConfig(cf.templates, name, _default, conditionContext);
        };

        /**
         * Promise.
         * Resolves custom HTML template url
         * @param name - alias name of the HTML template
         * @param _default - default value
         */
        this.resolveStyle = function (name, _default, conditionContext) {
            return resolveFromConfig(cf.styles, name, _default, conditionContext);
        };

        /**
         * Promise.
         * Resolves custom config object
         * @param name - alias name of the configuration section
         * @param _default - default value
         */
        this.resolveConfig = function (name, _default, conditionContext) {
            return resolveFromConfig(cf.configs, name, _default, conditionContext);
        };

        /**
         * Promise.
         * Resolves custom reports object
         * @param name - alias name of the report config
         * @param _default - default value
         */
        this.resolveReport = function (name, _default, conditionContext) {
            return resolveFromConfig(cf.reports, name, _default, conditionContext);
        };

        /**
         * Returns custom workflow configuration object
         * @param _default - default value
         */
        this.resolveWorkflow = function (_default, conditionContext) {
            return resolveFromConfig(cf.configs, "workflow-config", _default, conditionContext);
        };

        /**
         * Returns custom configuration object for a new order
         * @param _default - default value
         */
        this.resolveNewOrder = function (_default, conditionContext) {
            return resolveFromConfig(cf.configs, "new-order-config", _default, conditionContext);
        };

        /**
         * Returns custom configuration object for a new order types
         * @param _default - default value
         */
        this.resolveNewOrderTypes = function (_default, conditionContext) {
            return resolveFromConfig(cf.configs, "new-order-types-config", _default, conditionContext);
        };

        //endregion

        this.$get = function ($q, $log, $customisationConfig, context) {
            return new customResourceResolver($q, $log, $customisationConfig, context);
        };
    })

;
